import { useMemo } from 'react';

const START = 0;

const useTrimText = (text, max) => {
  const newText = useMemo(() => {
    if (text.length < max) {
      return text;
    }

    return text.slice(START, max).concat("...");
  }, [max, text]);
  return newText;
};

export { useTrimText as default };
